<template>
  <div>
    <div class="kc-crumbs">
      <a href="javascript:;">首页</a>
      <img src="../../assets/img/icon-more.png" />
<!--      <a href="javascript:;">全部课程</a>
      <img src="../../assets/img/icon-more.png" />
      <a href="javascript:;">坚信念</a>
      <img src="../../assets/img/icon-more.png" />
      <a href="javascript:;">方针政策</a>
      <img src="../../assets/img/icon-more.png" /> -->
      <router-link :to="`/CourseDetail?id=${courseId}`">{{courseName}}</router-link>
      <img src="../../assets/img/icon-more.png" />
      <a href="javascript:;" class="kc-crumbs-state">{{lessonName}}</a>
    </div>
    <div class="video-container">
      <div class="video-table">
        <div class="video-left">
            <video-player  class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @statechanged="playerStateChanged($event)"
            ></video-player>
        </div>
        <!-- <div class="video-right">
          <div class="video-right-title">
            <span>课程目录</span>
            <ul class="gdt">
              <li><a href="" title="中国粮食储蓄制度的历史演变中国粮食储蓄制度的历史演变中国粮食储蓄制度的历史演变">中国粮食储蓄制度的历史演变中国粮食储蓄制度的历史演变中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="" class="video-state">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
              <li><a href="">中国粮食储蓄制度的历史演变</a></li>
            </ul>
          </div>
        </div> -->
      </div>
      </div>
      <div class="evaluate-bg" v-show="dialog_show">
        <div class="evaluate">
          <h3>课程评价</h3>
          <ul>
            <li class="clearfix">
              <div class="fl evaluate-li-text">1、课程内容紧密联系个人需求</div>
              <el-rate class="fr evaluate-li-star" v-model="evaluate1"></el-rate>
            </li>
            <li class="clearfix">
              <div class="fl evaluate-li-text">2、课程内容重点突出、观点新颖</div>
              <el-rate class="fr evaluate-li-star" v-model="evaluate2"></el-rate>
            </li>
            <li class="clearfix">
              <div class="fl evaluate-li-text">3、能从课程中获取不同问题的解决方法</div>
              <el-rate class="fr evaluate-li-star" v-model="evaluate3"></el-rate>
            </li>
            <li class="clearfix">
              <div class="fl evaluate-li-text">4、讲师能够激发个人学习兴趣</div>
              <el-rate class="fr evaluate-li-star" v-model="evaluate4"></el-rate>
            </li>
            <li class="clearfix">
              <div class="fl evaluate-li-text">5、课程形式与时长安排合理</div>
              <el-rate class="fr evaluate-li-star" v-model="evaluate5"></el-rate>
            </li>
          </ul>
          <div class="evaluate-div">
            <div class="evaluate-btn" @click="dialog_show = false"><span>取消</span></div>
            <div class="evaluate-btn" @click="evaluateSubmit"><span>提交</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ApiGetCheckLesson, ApiSaveCourseProcess} from '../../net/accound/index.js'
import {ApiPointsOrder} from '../../net/home/index.js'
import {ApiPostevaluate} from '../../net/course/index.js'
export default {
  data: function () {
    return {
      playState: 0,
      lessonId: 0,
      courseId: 0,
      lessonName: '播放',
      courseName: '课程详情',
      isOver: 1, // 是否完成   1未完成   2已完成
      total: 0,
      progressDrag: 2, //单课件是否允许拖拽 （视频快进后退） 1允许 2不允许
      timer: null,
      isSave: true,
      playerOptions : {
          // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: 'http://sgn.vod.7east.cn/dde3e91b97ca4705aaa4f9a19cc29d2c/752f3bc2d2ac4434bbe701873be9e7ec-5a1d29c7ecef54d5e0c8782f9dd0a35f-ld.m3u8' //url地址
          }],
          poster: "../../assets/image/ic_user_avatar.png", //你的封面地址
          // width: document.documentElement.clientWidth, //播放器宽度
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
          }
      },
      evaluate1: 0,
      evaluate2: 0,
      evaluate3: 0,
      evaluate4: 0,
      evaluate5: 0,
      dialog_show: false
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    canDrag: function () {
      if (this.isOver == 2 || this.progressDrag == 1) {
        return true
      }
      return false
    }
  },
  methods:{
    onPlayerPlay: function () {
      this.total = parseInt(this.player.duration())
    },
    onPlayerPause: function () {

    },
    setTime: function () {
      const self = this;
      clearInterval(this.timer)
      this.timer = setInterval(()=>{
        console.log('111')
        self.saveCourseProcess()
      }, 30000)
    },
    playerStateChanged: function(playerCurrentState) {
      if (!playerCurrentState.timeupdate) {return}
      if (this.canDrag) { // 允许拖拽
        this.playState = parseInt(playerCurrentState.timeupdate)
        return
      }
      const _state = parseInt(playerCurrentState.timeupdate) - this.playState
      if (_state>2 || _state<-2) {
        this.player.currentTime(this.playState)
      } else {
        this.playState = parseInt(playerCurrentState.timeupdate)
      }
      if (this.isSave) {
        const _overState = parseInt(this.total) - this.playState
        if (this.total && _overState <= 5) {
          this.isSave = false
          this.saveCourseProcess()
        }
      }

    },
    getCheckLesson: function () {
      ApiGetCheckLesson({lessonId: this.lessonId}).then(res=>{
         console.log('课件地址', res)
        if (res.code == 200) {
          this.isOver = res.value.isOver || this.isOver
          this.courseId = res.value.courseId
          this.courseName = res.value.courseName
          this.lessonName = res.value.lessonName
          this.progressDrag = res.value.progressDrag
          this.$refs.videoPlayer.player.src(res.value.playUrl)
          this.playState = this.isOver == 2?0:res.value.process
          this.player.currentTime(this.playState)
        } else if (res.code == 4011) {
          this.$alert('您尚未开通该课件', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$route.back()
            }
          })
        }
      })
    },
    saveCourseProcess: function () {
      if (this.isOver == 2) {return} // 已完成
      const _overState = parseInt(this.total) - this.playState
      if (this.total && _overState <= 5 ) {
        this.isOver = 2
      }
      const prames = {
        lessonId: this.lessonId,
        courseId: this.courseId,
        process: this.playState,
        isOver: this.isOver,
        total: this.total || this.player.duration(),
        source: 'pc'
      }
      ApiSaveCourseProcess(prames).then(res=>{
        if(res.code == 200 && res.value.isFinish == 2) {
          this.isOver = 2
          this.$message.success(`该课件已听完，获得${res.value.score}学分`)
          this.dialog_show = true;
        }
      })
    },
    evaluateSubmit(){
      const uid = JSON.parse(localStorage.getItem('user')).uid;
      const prames = {
        cid: this.courseId,
        uid: uid,
        evaluate1:this.evaluate1,
        evaluate2:this.evaluate2,
        evaluate3:this.evaluate3,
        evaluate4:this.evaluate4,
        evaluate5:this.evaluate5,
      }
      ApiPostevaluate(prames).then(res=>{
        if(res.code == 200){
          this.$message.success(`提交成功`)
        }
        this.dialog_show = false
      })
    },
    pointsOrder: function () {
      const pramas = {
        orderType: 0,
        detailId: 2
      }
      ApiPointsOrder(pramas).then(res=>{
        console.log('res')
      })
    }
  },
  mounted: function () {
    this.lessonId = this.$route.query.lid
    this.getCheckLesson()
    this.setTime()
    this.pointsOrder()
  },
  beforeDestroy: function() {
   // this.player.dispose()
   clearInterval(this.timer)

  }
}
</script>

<style scoped>

.video-container{
  width: 100%;
  background-color: #191919;
}
.video-table{
  width: 1140px;
  margin:0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: -30px;
  overflow: hidden;
}
.kc-crumbs{
  width: 1140px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}
.kc-crumbs a{
  font-size: 16px;
  color: #7f7f7f;
  text-decoration: none;
  float: left;
}
.kc-crumbs img{
  width: 16px;
  height: 16px;
  float: left;
  margin-top: 4px;
  margin-left: 2px;
  margin-right: 2px;
}
.kc-crumbs a.kc-crumbs-state{
  color: #252525;
}
/* .video-left{
  width: 855px;
  height: 520px;
  background-color: #2d2d2d;
  float: left;
} */
.video-left{
  width: 855px;
  height: 480px;
  background-color: #2d2d2d;
  margin: 0 auto;
}
.video-right{
  width: 285px;
  float: right;
  background:#252525;
  height: 520px;
}
.video-right-title{
  width: 285px;
  height: 40px;
  border-bottom: 1px solid #333;
}
.video-right-title span{
  font-size: 16px;
  color:#fff;
  line-height: 40px;
  margin-left: 10px;
}
.video-right-title ul{
  margin:0;
  padding:0;
  height: 480px;
  overflow-y: auto;

}
.video-right-title ul li{
  list-style-type:none;
  overflow: hidden;
}
.video-right-title ul li a{
  text-decoration: none;
  font-size: 15px;
  color: #999;
  height:40px;
  line-height: 40px;
  float: left;
  padding-left: 10px;
  padding-right:10px;
  width: 265px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.video-right-title ul li a:hover{
  background:#1e1e1e;
  color:#0AAC50;
}
.video-right-title ul li a.video-state{
  background:#1e1e1e;
  color:#0AAC50;
}
.gdt{

}
.gdt::-webkit-scrollbar {/*滚动条整体样式*/

        width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/

        height: 1px;

    }

.gdt::-webkit-scrollbar-thumb {/*滚动条里面小方块*/

        border-radius: 10px;

         -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

        background: #ccc;

    }

.gdt::-webkit-scrollbar-track {/*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

        border-radius: 10px;

        background:#252525;

}
.evaluate-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.4);
  z-index: 999;
}
.evaluate{
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -260px;
  margin-left: -300px;
  width: 600px;
  height: 520px;
  background: #ffffff;
  border-radius: 10px;
  padding-bottom: 20px;
}
.evaluate h3{
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #252525;
  line-height: 25px;
  text-align: center;
  margin: 20px 0;
}
.evaluate li{
  height: 75px;
  width: 475px;
  line-height: 75px;
  margin: 0 auto;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  color: #333;
}
.evaluate .evaluate-li-star{
  margin-top: 25px;
}
.evaluate .evaluate-div{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top:30px;
}
.evaluate .evaluate-btn{
  width: 110px;
  height: 40px;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
}
.evaluate .evaluate-btn:hover{
  cursor: pointer;
}
.evaluate-btn:nth-of-type(1){
  border: 1px solid #dddddd;
  color: #888888;
}
.evaluate-btn:nth-of-type(2){
  border: 1px solid #0aac50;
  background: #0aac50;
  color: #ffffff;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Player/Player.vue